const sizes = [
  {
    value: "42",
    mm: "13,5MM",
  },
  {
    value: "43",
    mm: "13,75MM",
  },
  {
    value: "44",
    mm: "14MM",
  },
  {
    value: "45",
    mm: "14,25MM",
  },
  {
    value: "46",
    mm: "14,75MM",
  },
  {
    value: "47",
    mm: "15MM",
  },
  {
    value: "48",
    mm: "15,25MM",
  },
  {
    value: "49",
    mm: "15,5MM",
  },
  {
    value: "50",
    mm: "16MM",
  },
  {
    value: "51",
    mm: "16,25MM",
  },
  {
    value: "52",
    mm: "16,5MM",
  },
  {
    value: "53",
    mm: "17MM",
  },
  {
    value: "54",
    mm: "17,25MM",
  },
  {
    value: "55",
    mm: "17,5MM",
  },
  {
    value: "56",
    mm: "17,75MM",
  },
  {
    value: "57",
    mm: "18,25MM",
  },
  {
    value: "58",
    mm: "18,5MM",
  },
  {
    value: "59",
    mm: "18,75MM",
  },
  {
    value: "60",
    mm: "19MM",
  },
  {
    value: "61",
    mm: "19,5MM",
  },
  {
    value: "62",
    mm: "19,75MM",
  },
  {
    value: "63",
    mm: "20MM",
  },
  {
    value: "64",
    mm: "20,25MM",
  },
  {
    value: "65",
    mm: "20,75MM",
  },
  {
    value: "66",
    mm: "21MM",
  },
  {
    value: "68",
    mm: "21,75MM",
  },
];